import Option from './Option';
import { ControlInterface } from '../../../types/FormJson';

interface IsoTransitionsInterface extends ControlInterface {
	formInstanceId: string;
}

export default class IsoTransitions extends React.PureComponent<IsoTransitionsInterface> {
	render() {
		const {
			options,
			control: { params },
			name,
			onChange,
			formInstanceId,
			disabled,
		} = this.props;

		if (!options || !Array.isArray(options)) {
			return null;
		}

		return (
			<div className={`form-row row-${name} transitions`}>
				{options.map((option: any) => {
					return <Option key={option.value} {...{ name, formInstanceId, option, onChange, params, disabled }} />;
				})}
			</div>
		);
	}
}
